import React, { useContext, useRef, useEffect, useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { StoreContext } from '../contexts/StoreContext';
import Sidebar from './Sidebar';
import CrtSearch from './CrtSearch';
import portalIcon from '../assets/portal.gif';
import logoutIcon from '../assets/logout.svg';
import docsIcon from '../assets/docs.svg';
import storeIcon from '../assets/store.svg';
import moddableIcon from '../assets/moddable.svg';
import calculatorIcon from '../assets/calculator.svg';
import suntharLogo from '../assets/logo.png'
import accountIcon from '../assets/account.svg';
import './Navbar.css';

// With React you have to prefix the environment variable with REACT_APP_
const STORE_API_URL = process.env.REACT_APP_API_URL;
const STORE_MAIN_URL = process.env.REACT_APP_MAIN_URL;

const NavigationBar = ({ toggleTheme, isDarkTheme }) => {
  const { isAuthenticated, setIsAuthenticated, setToken, role } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false); 
  const navbarRef = useRef(null);
  const { stores, storeLogo } = useContext(StoreContext);
  const hasRealStore = stores.some((store) => store.is_cave !== true && store.is_cave !== 'true');

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      closeNavbar();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    // Store current path for redirect after login
    localStorage.setItem('postLoginRedirect', window.location.pathname);
    navigate('/login');
  };

  return (
    <Navbar ref={navbarRef} expand="lg" expanded={isOpen}>
        <Navbar.Brand
          as={Link}
          to={STORE_MAIN_URL}
          onMouseEnter={() => setIsHovered(true)} // Set hover state to true
          onMouseLeave={() => setIsHovered(false)} // Reset hover state to false
        >
          {isHovered ? (
            <img className="nav-logo" src={suntharLogo} alt="Sunthar Logo" style={{ height: '2.4rem' }}/>
          ) : storeLogo ? (
            <img className="nav-logo" src={storeLogo} alt="Store Logo" style={{ height: '2.4rem' }} />
          ) : (
            <img className="nav-logo" src={suntharLogo} alt="Sunthar Logo" style={{ height: '2.4rem' }}/>
          )}
        </Navbar.Brand>
        
        {/* CRT Search - always visible, positioned next to logo */}
        <div className="flex-grow-1 me-4" style={{ position: 'relative' }}>
          <CrtSearch 
            placeholder="Search CRTs..." 
            compact={true}
            className="navbar-crt-search"
          />
        </div>
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav"
          onClick={toggleNavbar}
          className={isOpen ? 'navbar-toggler open' : 'navbar-toggler'}
        >
          <div className="hamburger-icon">
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
          </div>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto" onClick={closeNavbar}>

            
            {/*
            <Nav.Link as={Link} to="https://store.sunthar.com">
              <img src={storeIcon} alt="Sunthar's Super Store" style={{ height: '30px', marginRight: '8px' }} />
              Super Store
            </Nav.Link>
            */}
            <Nav.Link as={Link} to="/moddable">
              <img src={moddableIcon} alt="RGB moddable CRTs" style={{ height: '30px', marginRight: '8px' }} />
              Moddable
            </Nav.Link>
            <Nav.Link as={Link} to="/rgb-mux-calculator">
              <img src={calculatorIcon} alt="RGB Multiplexer Calculator" style={{ height: '30px', marginRight: '8px' }} />
              Calculator
            </Nav.Link>
            <Nav.Link as={Link} to="https://sector.sunthar.com">
              <img src={docsIcon} alt="Sunthar's Super Sector" style={{ height: '30px', marginRight: '8px' }} />
              Super Sector
            </Nav.Link>
            <Nav.Link as={Link} to="https://store.sunthar.com">
              <img src={storeIcon} alt="Sunthar's Super Store" style={{ height: '30px', marginRight: '8px' }} />
              Super Store
            </Nav.Link>
            {/*
            <Nav.Link href="/signup">
              <img src={signupIcon} alt="Signup" style={{ height: '30px', marginRight: '8px' }} />
              Signup
            </Nav.Link>
            */}
            {/*
            <Nav.Link onClick={toggleTheme}>
              {isDarkTheme ? (
                <>
                  <FaSun style={{ marginRight: '5px' }} />Light
                </>
              ) : (
                <>
                  <FaMoon style={{ marginRight: '5px' }} />Dark
                </>
              )}
            </Nav.Link>
            */}
            {!isAuthenticated ? (
              <Nav.Link 
                href="#" 
                onClick={handleLogin}
              >
                <img src={portalIcon} alt="Login" style={{ height: '30px', marginRight: '8px' }} />
                Account
              </Nav.Link>
            ):(
              <Nav.Link as={Link} to="/dashboard">
                <img src={accountIcon} alt="Account" style={{ height: '30px', marginRight: '8px' }} />
                Account
              </Nav.Link>
            )}
            
            {/* Reuse Sidebar component for mobile authenticated navigation */}
            <Sidebar isMobile={true} closeNavbar={closeNavbar} />
          </Nav>
        </Navbar.Collapse>
    </Navbar>
  );
};

export default NavigationBar;